/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type purpose of the charging profile
 */
export enum ChargePointChargingProfilePurposeType {
  CHARGE_POINT_MAX_PROFILE = 'CHARGE_POINT_MAX_PROFILE',
  TX_DEFAULT_PROFILE = 'TX_DEFAULT_PROFILE',
  TX_PROFILE = 'TX_PROFILE'
}
